//export const CALENDLY_URL = "https://calendly.com/coliberalai/voice-demo";
// Royalty-free sample audio used as the demo placeholder. Replace with a real
// recording of the AI voice agent when available.
//export const DEMO_AUDIO_URL =
//  "./lib/recording.mp3";

export const audioURL = "/recording.mp3";

export const IMG = {
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/c6f4c993-7363-45e4-bbfd-f4b241fb2aaa/images/380202b1aa4bba13230b15c897ddc4ee01551866f7fd4599613fd5f8ccaebda3.png",
  coaching:
    "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1600&q=80",
  realEstate:
    "https://static.prod-images.emergentagent.com/jobs/c6f4c993-7363-45e4-bbfd-f4b241fb2aaa/images/9b48a02c91bbf88ffbea6c10b83c9116da304cc6a5d17714d88898af638d4d96.png",
  ecommerce:
    "https://static.prod-images.emergentagent.com/jobs/c6f4c993-7363-45e4-bbfd-f4b241fb2aaa/images/82dbcac7f47a878ba19535e6c4070132cabb62c0206c2abad238f35786f28698.png",
  avatar1:
    "https://images.pexels.com/photos/29368584/pexels-photo-29368584.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  avatar2:
    "https://images.unsplash.com/photo-1758613654360-45f1ff78c0cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMG5ldXRyYWwlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NjY4MzgyMnww&ixlib=rb-4.1.0&q=85",
};
